import { useState } from 'react';

export function useClipboard() {
  const [hasCopied, setHasCopied] = useState(false);

  const handleCopy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setHasCopied(true);
    } catch (err) {
      console.error(err);
    }
  };

  return {
    hasCopied,
    handleCopy,
  };
}
